// src/App.js
import React, { useContext, useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { AuthContext } from './context/AuthContext';
import { jwtDecode } from 'jwt-decode';

import NavBar from './components/NavBar';

import Feed from './pages/Feed';
import Login from './pages/Login';
import Register from './pages/Register';
import SubmitDog from './pages/SubmitDog';
import Profile from './pages/Profile';

// A helper component to extract token from the URL.
const TokenHandler = () => {
  const { updateUser } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();
  const processedRef = useRef(false); // Ref to ensure we process token only once

  useEffect(() => {
    // If we've already processed the token, do nothing.
    if (processedRef.current) return;

    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    if (token) {
      // Save token to localStorage
      localStorage.setItem('token', token);
      
      try {
        // Decode the JWT to extract user details.
        const decoded = jwtDecode(token);
        console.log("Decoded token:", decoded);
        
        // Create a user object from the token.
        // Adjust the field names based on your token's structure.
        const user = {
          email: decoded.email,
          username: decoded.username || decoded.email, // Use email as fallback if username is missing.
          // Add other fields as needed (e.g., id, name)
        };
        // Update the auth context with the new user info.
        updateUser(user);
      } catch (err) {
        console.error("Error decoding token:", err);
      }
      
      // Clean up URL by removing the token query param.
      navigate(location.pathname, { replace: true });
    }
  }, [location, navigate, updateUser]);

  return null;
};

function App() {
  return (
    <Router>
      <TokenHandler />
      <div className="min-h-screen bg-gray-100">
        <NavBar />
        <div className="container mx-auto mt-6">
          <Routes>
            <Route path="/" element={<Feed />} />
            <Route path="/submit" element={<SubmitDog />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/profile" element={<Profile />} />
          </Routes>
        </div>
        {/* Toast Container */}
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </Router>
  );
}

export default App;
